module.exports = __webpack_public_path__ + "static/media/smart-school.545859db.jpg";